<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='内容管理' subPath='栏目列表'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-button type="primary" @click="showAddDialog">添加栏目</el-button>
        </el-col>
      </el-row>
      <el-table :data="groupList" stripe border :cell-style="{ textAlign: 'center' }">
        <el-table-column prop="id" label="ID" align="center" width="50px"></el-table-column>
        <el-table-column prop="name" label="名称" align="center"></el-table-column>
        <el-table-column prop="icon" label="图标" align="center">
          <template slot-scope="scope">
            <el-image :src="scope.row.icon+'?imageView2/0/w/50'"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" align="center"></el-table-column>
        <el-table-column label="创建时间" align="center">
          <template slot-scope="scope">
            {{scope.row.create_time | dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="290px">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <category-group-add :visible="addDialogAvaible"
      :id="currentId"
      @add="addGroup"
      @update="updateGroup"
      @closeDialog="closeAddDialog"></category-group-add>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import CategoryGroupAdd from './GroupAdd.vue'
export default {
  name: 'category_group_list',
  components: {
    'bread-crumb': BreadCrumb,
    'category-group-add': CategoryGroupAdd
  },
  created () {
    this.getGroupList()
  },
  data () {
    return {
      currentId: 0,
      groupList: [],
      addDialogAvaible: false
    }
  },
  methods: {
    async getGroupList () {
      const res = await this.$http.get('/admin/category/group/list')
      if (res.code === 0) {
        this.groupList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async addGroup (data) {
      const res = await this.$http.post('/admin/category/group/add', data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getGroupList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async updateGroup (id, data) {
      const res = await this.$http.post('/admin/category/group/update/' + id, data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getGroupList()
      } else {
        this.$message.error(res.msg)
      }
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    closeAddDialog () {
      this.addDialogAvaible = false
      this.currentId = 0
    },
    showEditDialog (id) {
      this.currentId = id
      this.showAddDialog()
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/category/group/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getGroupList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.el-image {
  width: 50px;
}
</style>
